export const ROMANIZATION_TEXT_ATTR = 'data-romanization';

/** Combining marks after NFD (tones, accents, underdots). BMP range only. */
const COMBINING_MARK_RE = /[\u0300-\u036F]/;

export const hasLatinDiacritics = (text: string | null | undefined): boolean => {
  if (typeof text !== 'string' || !text) {
    return false;
  }
  try {
    return COMBINING_MARK_RE.test(text.normalize('NFD'));
  } catch {
    return false;
  }
};

/** Marks romanisation that needs Figtree so tone marks stay aligned. */
export const romanizationTextAttrs = (text?: string | null): Record<string, string> =>
  hasLatinDiacritics(text) ? { [ROMANIZATION_TEXT_ATTR]: 'true' } : {};
